<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-20 10:42:48
 * @LastEditTime: 2021-08-21 15:42:29
 * @Description: 添加泵车公司
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\pumpTruckDistribution\addPumpTruckCompany.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonFormStyles addPumpTruckCompany">
            <van-nav-bar
                title="添加泵车公司"
                left-text="泵车派发"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section class="showFontBtn">
                <div class="essentialInfo">
                    <van-collapse v-model="activeNames">
                        <van-collapse-item name="1">
                            <div slot="title" class="title">
                                <i class="iconfont icondingdan"></i>
                                <span>基本信息</span>
                            </div>
                            <van-cell
                                :value="clueData.task_number"
                                title="任务编号"
                                :icon="require('@/assets/images/icons/icon_gy_1.png')"
                            ></van-cell>
                            <van-cell
                                :icon="require('@/assets/images/icons/icon_gy_7.png')"
                                title="要求到货时间"
                                :value="clueData.arrival_time"
                                default-date
                            >
                            </van-cell>
                            <van-cell
                                :icon="require('@/assets/images/icons/icon_2.png')"
                                title="工程名称"
                                :value="clueData.project_name"
                                default-date
                            >
                            </van-cell>
                            <van-cell
                                :icon="require('@/assets/images/icons/icon_30.png')"
                                title="订单方量"
                                :value="clueData.plan_quantity"
                                default-date
                            >
                            </van-cell>
                            <van-cell
                                :icon="require('@/assets/images/icons/icon_gy_3.png')"
                                title="强度等级"
                                :value="clueData.strength_grade_name"
                                default-date
                            >
                            </van-cell>
                        </van-collapse-item>
                    </van-collapse>
                </div>
                <dl class="pumpTruckList">
                    <dt>
                        <h3 class="iconfont iconpingjia">
                            泵车公司
                        </h3>
                        <span
                            class="iconfont icontianjiazengjiajia"
                            @click="selectPumpTruckCompany"
                        >
                            添加
                        </span>
                    </dt>
                    <dd>
                        <van-cell
                            :icon="require('@/assets/images/icons/icon_gy_5.png')"
                            title="浇筑方式"
                            v-model="clueData.pouring_name"
                            @click="handleChoosePour"
                        >
                        </van-cell>
                        <van-action-sheet v-model="showChoosePour" :actions="pouringList" @select="onSelectPour"></van-action-sheet>
                    </dd>
                    <template v-for="(item, index) in pumpTruckData">
                        <dd :key="`pumpTruck_${index}`">
                            <van-cell
                                :title="item.pump_company_name"
                                :icon="require('@/assets/images/icons/icon_gy_8.png')"
                            >
                                <template #right-icon>
                                    <button class="deleteBtn" @click="deletePumpTruck(index)">
                                        删除
                                    </button>
                                </template>
                            </van-cell>
                            <van-cell
                                is-link
                                title="泵送高度"
                                :icon="require('@/assets/images/icons/icon_16.png')"
                                :value="item.pump_company_truck_name"
                                @click="selectPumpingHeight(index)"
                            >
                            </van-cell>
                        </dd>
                    </template>
                </dl>
                <van-popup
                    v-model="pumpingHeightShow"
                    position="bottom"
                >
                    <van-picker
                        show-toolbar
                        :columns="pumpingHeight"
                        value-key="name"
                        @cancel="pumpingHeightShow = false"
                        @confirm="confirmPumpingHeight"
                    ></van-picker>
                </van-popup>
            </section>
            <footer class="commonFormBtns">
                <van-button
                    type="info"
                    @click="savePumpTruck"
                >
                    保存
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
import { Dialog } from 'vant';

export default {
    name: 'add-pump-truck-company',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/pumpTruckDistribution') {
            this.$store.commit('noKeepAlive', 'add-pump-truck-company');
        }
        next();
    },
    data() {
        return {
            activeNames: ['1'],
            // 基本信息
            clueData: {},
            // 泵车物流公司数据
            pumpTruckData: [],
            pumpTruckIndex: 0,
            // 泵送高度
            pumpingHeight: [],
            pumpingHeightShow: false,

            // 显示选择浇筑方式
            showChoosePour: false,
            // 浇筑方式列表
            pouringList: [],
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.clueData = this.$route.params.item;
        this.pumpTruckData = await this.getPumpTruckData();
        this.pumpingHeight = await this.getPumpingHeight();
        await this.getPourList();
    },
    activated() {
        // 选择泵车公司返回
        if (this.$route.params.selectData) {
            this.$route.params.selectData.forEach(item => {
                this.pumpTruckData.push({
                    pump_company_code: item.pump_company_code,
                    pump_company_name: item.pump_company_name,
                    pump_company_sh_name: item.pump_company_sh_name,
                    pump_company_truck: '',
                    pump_company_truck_name: '',
                });
            });
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 添加泵车公司
        selectPumpTruckCompany() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'selectPumpTruckCompany',
            });
        },
        // 删除泵车公司
        deletePumpTruck(index) {
            this.pumpTruckData.splice(index, 1);
        },
        // 选择泵送高度
        selectPumpingHeight(index) {
            if (this.checkDisablePumpingHeight()) {
                this.pumpTruckIndex = index;
                this.pumpingHeightShow = true;
            }
        },
        // 确认选择泵送高度
        confirmPumpingHeight(data) {
            this.pumpingHeightShow = false;
            this.pumpTruckData[this.pumpTruckIndex].pump_company_truck = data.code;
            this.pumpTruckData[this.pumpTruckIndex].pump_company_truck_name = data.name;
        },
        // 保存
        savePumpTruck() {
            this.$axios
                .post('/interfaceApi/production/producttask/pumptruckdistribute', {
                    task_number: this.clueData.task_number,
                    pouring: this.clueData.pouring,
                    pouring_name: this.clueData.pouring_name,
                    companies: this.pumpTruckData,
                })
                .then(res => {
                    this.$toast.success(res);
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },

        // 获取泵送高度
        getPumpingHeight() {
            return this.$axios.$get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=303-BS0', { defEx: true });
        },

        // 初始化已选泵车物流公司数据
        getPumpTruckData() {
            return this.$axios.$get(`/interfaceApi/production/producttask/pumptruckcompanies/${this.clueData.task_number}`, { defEx: true });
        },
        // 选择浇筑方式
        handleChoosePour() {
            if (this.clueData.can_change_pouring) {
                this.showChoosePour = true;
            }
        },
        // 选择浇筑方式回调
        onSelectPour(item) {
            this.$dialog.confirm({
                message: `当前订单选择的浇筑方式为${this.clueData.pouring_name}，是否要更改为${item.name}？`,
            }).then(() => {
                this.clueData.pouring = item.code;
                this.clueData.pouring_name = item.name;
            }).catch(() => {}).finally(() => {
                this.showChoosePour = false;
            });
        },
        checkDisablePumpingHeight() {
            // 如果浇筑方式是车载泵，则泵送高度不能选择
            if (this.clueData.pouring === '302-JZ0-03') {
                return false;
            }
            return true;
        },
        // 选择浇筑方式列表
        async getPourList() {
            const list = await this.getDicList('302-JZ0');
            list.forEach(item => {
                this.pouringList.push({
                    name: item.name,
                    code: item.code,
                });
            });
        },
        // 获取字典列表
        getDicList(code) {
            const tenant_id = this.$takeTokenParameters('TenantId');
            const url = `/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=${code}&tenant_id=${tenant_id}&sort_type=0`;
            return this.$axios.$get(url, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.addPumpTruckCompany
    height 100%
    section
        .essentialInfo
            >>>.van-collapse
                .title
                    span
                        padding-left 5rpx
                .van-collapse-item__content
                    padding 0
        .pumpTruckList
            padding 14rpx
            background #F0F0F0
            dt
                display flex
                justify-content space-between
                h3,span
                    line-height 18rpx
                h3
                    font-size 18rpx
                    color #3495FB
                span
                    font-size 14rpx
                    color #666666
            dd
                margin-top 10rpx
                &:nth-of-type(1)
                    margin-top 15rpx
                .van-cell
                    padding 6rpx 14rpx
                    .deleteBtn
                        color #FF4D4F
                        border 1px solid #FFA39E
                        background #FFF1F0
                        font-size 12rpx
                        line-height 22rpx
                        padding 0 8rpx
                        border-radius 3rpx
</style>
